module.exports = __webpack_public_path__ + "img/weixin_1.85701ebc.png";